<template>
  <div class="container">
    <h2 class="section-title">产品 & 解决方案</h2>
    <p class="section-sub">为手术室提供全流程数智化物资管理方案</p>
    <div class="grid-3">
      <div v-for="item in productList" :key="item.id" class="card">
        <img :src="item.img" :alt="item.name">
        <div class="card-body">
          <h3>{{ item.name }}</h3>
          <p>{{ item.summary }}</p>
          <router-link :to="item.link" class="btn-primary">查看详情 →</router-link>
        </div>
      </div>
    </div>

    <div class="spacing-section"></div>

    <!-- 产品介绍横幅 -->
    <div class="products-banner">
      <div class="banner-content">
        <h1 class="banner-title">智慧手术室物资管理专家</h1>
        <p class="banner-subtitle">基于物联网与人工智能技术，打造手术室物资全流程数字化管理平台</p>
        
        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-icon">🔧</div>
            <h4>智能物联</h4>
            <p>RFID、人脸识别、传感器等技术实现物资精准管理</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">📊</div>
            <h4>数据分析</h4>
            <p>大数据分析平台，提供运营决策支持与优化建议</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">🔒</div>
            <h4>安全保障</h4>
            <p>多重安全防护机制，确保医疗物资使用安全合规</p>
          </div>
        </div>
        
        <div class="tech-stats">
          <div class="tech-item">
            <span class="tech-label">识别准确率</span>
            <span class="tech-value">≥99.8%</span>
          </div>
          <div class="tech-item">
            <span class="tech-label">响应时间</span>
            <span class="tech-value">&lt;0.5秒</span>
          </div>
          <div class="tech-item">
            <span class="tech-label">系统可用性</span>
            <span class="tech-value">99.9%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productList: [
        { id: 'behavior', name: '手术室行为管理系统', summary: '行为规范管理，人员智能追踪，衣鞋柜联动，提升效率。', img: '/img/home/1.png', link: '/products/behavior' },
        { id: 'anesthesia', name: '麻醉药品管理系统', summary: '药品闭环管控，套餐箱/柜车双模式，确保用药安全。', img: '/img/home/2.png', link: '/products/anesthesia' },
        { id: 'consumables', name: '手术室耗材管理系统', summary: '智能耗材库+柜/仓一体化，高值耗材全程追溯。', img: '/img/home/3.png', link: '/products/consumables' },
        { id: 'treatment', name: '智慧治疗室', summary: '智能化治疗流程管理，提升治疗效率和患者体验。', img: '/img/home/4.png', link: '/products/treatment' },
        { id: 'pathology', name: '手术室病理标本管理系统', summary: '病理标本全流程追踪，确保标本安全与可追溯。', img: '/img/home/6.png', link: '/products/pathology' },
        { id: 'asset', name: '智慧手术室物资管理系统', summary: '全方位物资管理，智能盘点，优化库存配置。', img: '/img/home/7.png', link: '/products/asset' }
      ]
    };
  },
  mounted() {
    // 添加滚动动画效果
    this.$nextTick(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      });

      const elements = document.querySelectorAll('.feature-item, .tech-item, .card');
      elements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'all 0.6s ease';
        observer.observe(el);
      });
    });
  }
};
</script>

<style scoped>
.container { max-width: 1280px; margin: 0 auto; padding: 48px 24px; }

.spacing-section {
  height: 60px;
}

/* 产品介绍横幅 */
.products-banner {
  background: linear-gradient(135deg, #0f2b36 0%, #1a4a5c 50%, #1f8aad 100%);
  border-radius: 32px;
  padding: 60px 40px;
  margin-bottom: 60px;
  color: white;
  box-shadow: 0 20px 40px rgba(15, 43, 54, 0.3);
  text-align: center;
}

.banner-content {
  max-width: 900px;
  margin: 0 auto;
}

.banner-title {
  font-size: 38px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
}

.banner-subtitle {
  font-size: 18px;
  margin-bottom: 40px;
  opacity: 0.9;
  line-height: 1.6;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 32px;
}

.feature-item {
  text-align: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
}

.feature-icon {
  font-size: 32px;
  margin-bottom: 12px;
}

.feature-item h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: white;
}

.feature-item p {
  font-size: 14px;
  opacity: 0.8;
  line-height: 1.4;
}

.tech-stats {
  display: flex;
  gap: 32px;
  justify-content: center;
}

.tech-item {
  text-align: center;
}

.tech-label {
  display: block;
  font-size: 14px;
  opacity: 0.8;
  margin-bottom: 4px;
}

.tech-value {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #7ab7cc;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .products-banner {
    padding: 40px 24px;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .tech-stats {
    flex-direction: column;
    gap: 16px;
  }
}

.section-title { font-size: 32px; font-weight: 700; text-align: center; margin-bottom: 16px; color: #0f2b36; }
.section-sub { text-align: center; color: #4b5563; max-width: 700px; margin: 0 auto 40px; }
.grid-3 { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 32px; }
.card { background: white; border-radius: 24px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.05); transition: 0.3s; }
.card:hover { transform: translateY(-5px); }
.card img { width: 100%; height: 220px; object-fit: cover; }
.card-body { padding: 24px; }
.card-body h3 { margin-bottom: 12px; }
.card-body p { color: #4b5563; margin-bottom: 20px; }
.btn-primary { background-color: #1f8aad; color: white; padding: 10px 24px; border-radius: 40px; text-decoration: none; display: inline-block; }
</style>